// Last-resort UI when a render error escapes to the Sentry ErrorBoundary.
// Deliberately self-contained — no auth / router / design-context imports —
// so it still renders even if one of those providers is what crashed. Uses
// only the global design tokens (CSS vars) already loaded via styles.css.
export function CrashFallback() {
  return (
    <div
      className="pt-app pt-shell"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: 300 }}>
        <div className="t-h1" style={{ marginBottom: 8 }}>Что-то пошло не так</div>
        <div className="t-caption" style={{ marginBottom: 20, color: 'var(--text-3)', lineHeight: 1.5 }}>
          Приложение столкнулось с ошибкой. Мы уже знаем о ней — попробуйте перезапустить.
        </div>
        <button
          onClick={() => window.location.reload()}
          style={{
            background: 'var(--accent)',
            color: 'var(--on-accent, #fff)',
            border: 'none',
            borderRadius: 12,
            padding: '12px 20px',
            font: 'inherit',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Перезапустить
        </button>
      </div>
    </div>
  )
}
